module.exports = __webpack_public_path__ + "static/img/product3-6.e5aa161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3-6.jpg
// module id = 30Xw
// module chunks = 0